import React from 'react';
import { string } from 'prop-types';

const ImplementActiveColor = ({
  className = '',
  color = '#14803c',
}) => (
  <svg className={className} width="1.4rem" height="1.4rem" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M3.42802 1.45605H4.59469L5.75639 6.12327L8.23456 6.12444L7.07257 1.45605H8.23924L9.91675 8.16667H11.0834V7.29167C11.0834 6.80831 11.4752 6.41667 11.9584 6.41667C12.4416 6.41667 12.8334 6.80831 12.8334 7.29167V10.2083C12.8334 10.6917 12.4416 11.0833 11.9584 11.0833C11.4752 11.0833 11.0834 10.6917 11.0834 10.2083V9.33333H9.91675V11.0833L8.75008 12.25V9.33333H7.58341V11.0833L6.41675 12.25V9.33333H5.25008V11.0833L4.08341 12.25V9.33333H2.91675V10.2083C2.91675 10.6917 2.52496 11.0833 2.04175 11.0833C1.55853 11.0833 1.16675 10.6917 1.16675 10.2083V7.29167C1.16675 6.80831 1.55853 6.41667 2.04175 6.41667C2.52496 6.41667 2.91675 6.80831 2.91675 7.29167V8.16667H4.08341L4.59199 6.13238L3.42802 1.45605ZM5.54175 7L5.25008 8.16667H8.75008L8.45841 7H5.54175Z" fill={color} />
  </svg>
);

ImplementActiveColor.propTypes = {
  className: string,
  color: string,
};

export default ImplementActiveColor;
